<template>
  <section class="grid-main container">
    <div class="col-span-12 lg:col-span-9 text-block">
      <div id="cookie-data" />
    </div>
  </section>
</template>
<script setup>
// append the script to the cookie-consent div
onMounted(() => {
  setTimeout(() => {
    const script = document.createElement('script');
    script.src = 'https://consent.cookiebot.com/0631afc5-3a6e-43d0-beeb-d09252a9222e/cd.js';
    script.async = true;
    document.getElementById('cookie-data').appendChild(script);
  }, 500);
});
</script>
